import React, { useState, useEffect } from 'react';
//import { Button, Card, Col, Container, Dropdown, DropdownButton, Form,  Modal, OverlayTrigger, Row, Table, Tooltip } from "react-bootstrap";
import { Button, Card, Col, Container, Form, Modal, OverlayTrigger, Tooltip, Row, Table } from "react-bootstrap";
//import { PencilIcon } from '@primer/octicons-react'
//import { BiPlus, BiTrash } from "react-icons/bi";
import { BiTrash } from "react-icons/bi";
import { axiosAuth_DATA_MGMT_API } from '../utils/AxoisUtilComponent';
//import { axiosAuth_IDENT_MGMT_API } from '../utils/AxoisUtilComponent';
import { useTranslation } from 'react-i18next';
import classes from './AdminPages.module.css';
import { translateAPIError } from '../utils/apiUtils';
import { formatDate } from '../utils/timeUtils';


const NotifAdminDetailsView = (props) => {

  // Utilities
  const { t } = useTranslation(['common', 'custom']);

  // Initialize with actual JSON obj.  If not, will get error.
  const [notifAttrs, setNotifAttrs] = useState({
    id: '',
    typeName: '',
    attrs: '',
    msgs: ''
  });


  // View vs Edit Modes
  //const [editMode, setEditMode] = useState(false);

  const [showDeleteConfirmDialog, setShowDeleteConfirmDialog] = useState(false);
  const [deleteTarget,            setDeleteTarget]            = useState(null);
  const [errMsgDeleteConfirm,     setErrMsgDeleteConfirm]     = useState('');

  const [errMsg, setErrMsg] = useState('');

  //const [errMsg_Update,      setErrMsg_Update] = useState('');

  //const [notifTypeList,      setNotifTypeList] = useState([]);

  const [userList, setUserList] = useState([]);

  //const [showUserInfo, setShowUserInfo] = useState(false);
  //const [userSelected, setUserSelected] = useState();

  //const [userAddList, setUserAddList] = useState([]);

  //const [unassignedUserList, setUnassignedUserList] = useState();

  //const [showAddUserDialog, setShowAddUserDialog] = useState(false);
  //const [addUserErrMsg, setAddUserErrMsg] = useState('');


  // UI Functions

  // Initialize state
  useEffect(() => {
    if (props) {
      setNotifAttrsWithFormatting (props.objDetails);

      //fetchNotifTypes();

      fetchAssociatedUsers(props.objDetails.id);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props]);


  const setNotifAttrsWithFormatting = (details) => {

    if (!details)
      return;

    // Properly format receiver settings JSON
    // Makes a deep copy
    let formattedDetails = JSON.parse (JSON.stringify (details));

    formattedDetails.attrs = (details.attrs  === null) ? '' :
                             JSON.stringify(JSON.parse(JSON.stringify(details.attrs)),  undefined, 4);

    formattedDetails.msgs  = (details.msgs  === null) ? '' :
                             JSON.stringify(JSON.parse(JSON.stringify(details.msgs)),  undefined, 4);

    setNotifAttrs(formattedDetails);
  }


/*
  const fetchNotifTypes = () => {

    return new Promise(async (resolve, reject) => {
      try {
        const res = await axiosAuth_DATA_MGMT_API.get("notif-types");

        resolve(res.data);

        if (   (res.status === 200)
            && (res.data && res.data.length > 0)) {
          setNotifTypeList(res.data);
        }

        setErrMsg('');
      } catch (error) {
        setErrMsg(t(translateAPIError(error)));
      }
    });
  }
*/

  const fetchAssociatedUsers = (notifId) => {

    if (!notifId) {
      return;
    }

    return new Promise(async (resolve, reject) => {
      try {
        const res = await axiosAuth_DATA_MGMT_API.get("notifs/" + notifId + "/users");

        resolve(res.data);

        if (res.status === 200) {
          setUserList(res.data);
        }

        setErrMsg('');
      } catch (error) {
        setErrMsg(t(translateAPIError(error)));
      }
    });
  }


/*
  const fetchUnassignedUsers = () => {

    return new Promise(async (resolve, reject) => {
      try {
        const res = await axiosAuth_IDENT_MGMT_API.get("users");

        resolve(res.data);

        if (res.status === 200) {

          // Assign to a cleanList in case there are group entries are reserved.  But nothing at this moment.
          const cleanList = res.data;

          // Remove datapoint types already assigned to the user
          let tmpList = [];

          for (let i=0; i<userList.length; i++) {
            tmpList.push(userList[i].id);
          }

          let newList = [];
          for (let i=0; i<cleanList.length; i++) {
            if (!tmpList.includes(cleanList[i].id)) {
              newList.push(cleanList[i]);
            }
          }

          setUnassignedUserList(newList);
        }

        setErrMsg('');
      } catch (error) {
        setErrMsg(t(translateAPIError(error)));
      }
    });
  }


  const handleEditAttrs = (e) => {
    e.preventDefault();
    //setEditMode(true);
  }

  const onNotifTypeSelect = (key, event) => {
    setNotifAttrs({ ...notifAttrs, id: key })
  };

  const onAttrsInputChange = (e) => {
    setNotifAttrs({ ...notifAttrs, [e.target.name]: e.target.value })
  }

  const handleEditCancel = (e) => {
    e.preventDefault();

    // Reset fields
    setNotifAttrsWithFormatting (props.NotifDetails);

    //setEditMode(false);
  }

  const handleEditSubmit = (e) => {
    e.preventDefault();

    const reqBody = notifAttrs;

    return new Promise(async (resolve, reject) => {
      try {
        const res = await axiosAuth_DATA_MGMT_API.put("notifs", reqBody);

        resolve(res.data);

        if (res.status === 200) {

          // Restore UI to viewing mode
          //setEditMode(false);
        }
      } catch (error) {
        setErrMsg(t(translateAPIError(error)));
      }
    });

  }
*/


  const handleClose = (e) => {
    e.preventDefault();

    // Return to list
    props.onUIMode('LIST')
  }



/*
  function handleUserInfo(user) {

    setUserSelected(user);
    setShowUserInfo(true);
  }

  const handleUserInfoClose = (e) => {
    setUserSelected(null);
    setShowUserInfo(false);
  }


  function handleAddUsers() {
    fetchUnassignedUsers();
    setShowAddUserDialog(true);
  }

  function handleAddUsersClose() {
    setUserAddList([]);
    setShowAddUserDialog(false);
  }

  function handleAddUsersSubmit() {
    let userIds = [];

    if (userAddList.length === 0) {
      setShowAddUserDialog(false);
      return;
    }

    for (let i=0; i<userAddList.length; i++) {
      userIds.push(userAddList[i]);
    }

    let reqBody = {
          userList: userIds
        };

    return new Promise(async (resolve, reject) => {
      try {

        const res = await axiosAuth_DATA_MGMT_API.post("notifs/" + notifAttrs.id + "/users", reqBody);

        resolve(res.data);

        if (res.status === 200) {
          setUserAddList([]);
          setAddUserErrMsg('');
          setShowAddUserDialog(false);
          fetchAssociatedUsers(notifAttrs.id);
        } else {
          // ##### NEED TO DECIDE WHAT TO DO #####
        }
      } catch (error) {
        setAddUserErrMsg(t(translateAPIError(error)));
      }
    });
  }
*/


  function handleRemoveUser(user) {
    setDeleteTarget(user);
    setShowDeleteConfirmDialog(true);
  }

  function handleDeleteConfirmCancel() {
    setDeleteTarget(null);
    setErrMsgDeleteConfirm('');
    setShowDeleteConfirmDialog(false);
  }

  function handleDeleteConfirmSubmit() {

    let reqBody = {
          data: {
             "userIds": []
          }
        };

    reqBody.data.userIds.push(deleteTarget.id);

    return new Promise(async (resolve, reject) => {
      try {

        const res = await axiosAuth_DATA_MGMT_API.delete("notifs/" + notifAttrs.id + "/users/", reqBody);

        resolve(res.data);

        if (res.status === 200) {
          setErrMsg('');
          setShowDeleteConfirmDialog(false);
          fetchAssociatedUsers(notifAttrs.id);
        } else {
          // ##### NEED TO DECIDE WHAT TO DO #####
        }
      } catch (error) {
        setErrMsg(t(translateAPIError(error)));
      }
    });
  }

/*
  const handleUserSelect = (e) => {

    if (e.target.checked) {
      // Add user to the list
      userAddList.push(e.target.id);
    } else {
      const index = userAddList.indexOf(e.target.id);
      if (index > -1) {
        userAddList.splice(index, 1);
      }
    }

    setUserAddList(userAddList);
  }
*/


  function renderUser(user, index) {
    return (
      <tr key={index} style={{fontWeight:'300'}}>
{/*
        <td><span style={{cursor:'pointer', color:'SteelBlue'}} onClick={() => handleUserInfo(user)}>{user.name}</span></td>
*/}
        <td>{user.username}</td>
        <td>{user.status}</td>
        <td>
          <OverlayTrigger overlay={<Tooltip id="tooltip-delete-loc" style={{fontSize:'11px'}}>{t("I18N_TIP_Delete_recipient")}</Tooltip>}>
            <span style={{cursor:'pointer', color:'SteelBlue'}} onClick={() => handleRemoveUser(user)}><BiTrash size={16} /></span>
          </OverlayTrigger>
        </td>
      </tr>
    )
  }


/*
  function renderAddNotifs(user, index) {
    return (
      <tr key={index} style={{fontWeight:'300'}}>
        <td><Form.Check type="checkbox" id={user.id} label="" onChange={handleUserSelect} /></td>
        <td>{user.username}</td>
      </tr>
    )
  }
*/


  return (
    <>
      <Card style={{overflow:'auto', border:'0', boxShadow:'0 2px 2px 0px rgba(0,0,0,0.1)',
                    padding:'20px 40px 20px 40px', maxWidth:'2500px', width:'100%', fontSize:'13px'}}>

        <div style={{display:'flex'}}>
        <span className={classes.admin_pages__page_title}>
          {t("I18N_Notif_Details")}
        </span>
        </div>

        <div className={classes.admin_pages__page_subtitle} style={{marginTop:'20px'}}>
          <div display='flex'>
            <span>
              {t("I18N_Notif_info")}
            </span>
{/*
            {editMode ?
              null
              :
              <span style={{marginLeft:'15px', fontSize:'9px', color:'SteelBlue', cursor:'pointer'}} onClick={handleEditAttrs}>
                <PencilIcon size={12} />
                {t("I18N_Edit")}
              </span>
            }
*/}
          </div>
          <hr className="solid" style={{ margin: '0 0 10px 0' }}></hr>

{/*
          {editMode ?
            <Container>
              <form>
                <Row className={classes.admin_pages__field_label}>
                  <Col md={3}>{t("I18N_Notif_id")}:</Col>
                  <Col md={3}>{t("I18N_Notif_type_name")}: *</Col>
                  <Col md={3}></Col>
                  <Col md={3}></Col>
                </Row>
                <Row className={classes.admin_pages__field_value}>
                  <Col md={3}>{notifAttrs.id}</Col>
                  <Col md={3}>
                    <DropdownButton size="tiny_dropdown" variant="outline-secondary" id="dropdown-basic-button"
                      title={!notifAttrs.id ? t("common:I18N_DROPDOWN_PROMPT") :
                              (notifTypeList.find( ({ id }) => id === parseInt(notifAttrs.typeId) )).name}
                      onSelect={onNotifTypeSelect}>
                      {notifTypeList.map((item, index) => {
                        return (
                          <Dropdown.Item key={index} eventKey={item.id} className={classes.dropdown_item_wrap}>
                            {item.name}
                          </Dropdown.Item>
                        );
                      })}
                    </DropdownButton>
                  </Col>
                  <Col md={3}></Col>
                  <Col md={3}></Col>
                </Row>

                <Row className={classes.admin_pages__field_label} style={{ marginTop: '10px' }}>
                  <Col sm={{span: 12}}>{t("I18N_Attrs")}:</Col>
                </Row>
                <Row className={classes.admin_pages__field_value}>
                  <Col sm={{span: 12}}>
                    <textarea rows={3} className={classes.admin_pages__field_editable} style={{minWidth: '100%'}} name="attrs"
                              value={notifAttrs.attrs} onChange={(e) => onAttrsInputChange(e)} />
                  </Col>
                </Row>

                <Row className={classes.admin_pages__field_label} style={{ marginTop: '10px' }}>
                  <Col sm={{span: 12}}>{t("I18N_Messages")}:</Col>
                </Row>
                <Row className={classes.admin_pages__field_value}>
                  <Col sm={{span: 12}}>
                    <textarea rows={6} className={classes.admin_pages__field_editable} style={{minWidth: '100%'}} name="msgs"
                              value={notifAttrs.msgs} onChange={(e) => onAttrsInputChange(e)} />
                  </Col>
                </Row>

                <Row className={classes.admin_pages__field_label} style={{marginTop:'10px', fontStyle:'italic'}}>
                  <span>{t("I18N_Req_fields")}</span>
                </Row>

                <Row>
                  <div display='flex' style={{marginTop:'15px'}}>
                    <Button size="tiny" variant="outline-secondary" className="mb-3"
                      style={{ float: 'left' }}
                      onClick={handleEditCancel}>
                      {t("I18N_Cancel")}
                    </Button>
                    <Button size="tiny" variant="outline-secondary" className="mb-3"
                      style={{ marginLeft: '15px' }}
                      onClick={handleEditSubmit}>
                      {t("I18N_Save")}
                    </Button>
                    <span className={classes.admin_pages__field_label} style={{marginLeft:'30px', color:'rgba(200,0,0)', verticalAlign:'top'}}>
                      {errMsg}
                    </span>
                  </div>
                </Row>
              </form>
            </Container>
            :
*/}
            <Container>
              <Row className={classes.admin_pages__field_label}>
                <Col md={3}>{t("I18N_Notif_id")}: *</Col>
                <Col md={3}>{t("I18N_Subject")}:</Col>
                <Col md={3}>{t("I18N_Type")}:</Col>
                <Col md={3}>{t("I18N_Time_created")}:</Col>
              </Row>
              <Row className={classes.admin_pages__field_value}>
                <Col md={3}>{notifAttrs.id}</Col>
                <Col md={3}>{notifAttrs.subject}</Col>
                <Col md={3}>{notifAttrs.typeName}</Col>
                <Col>{formatDate(notifAttrs.timeCreated)}</Col>
              </Row>

              <Row className={classes.admin_pages__field_label} style={{ marginTop: '10px' }}>
                <Col sm={{span: 12}}>{t("I18N_Attrs")}:</Col>
              </Row>
              <Row className={classes.admin_pages__field_value}>
                <Col sm={{span: 12}}>
                  <textarea readOnly rows={3} className={classes.admin_pages__field_editable} style={{minWidth: '100%'}} name="attrs"
                            value={notifAttrs.attrs} />
                </Col>
              </Row>

              <Row className={classes.admin_pages__field_label} style={{ marginTop: '10px' }}>
                <Col sm={{span: 12}}>{t("I18N_Messages")}:</Col>
              </Row>
              <Row className={classes.admin_pages__field_value}>
                <Col sm={{span: 12}}>
                  <textarea readOnly rows={6} className={classes.admin_pages__field_editable} style={{minWidth: '100%'}} name="msgs"
                            value={notifAttrs.msgs} />
                </Col>
              </Row>

            </Container>
{/*
          }
*/}
        </div>

        <div className={classes.admin_pages__page_subtitle} style={{marginTop:'30px'}}>
          <div style={{display:'flex'}}>
            <span>
              {t("I18N_User_assoc_with_notif")}
            </span>
{/*
            <span style={{marginLeft:'auto', marginRight:'20px'}}>
              <OverlayTrigger overlay={<Tooltip id="tooltip-new_dpType" style={{fontSize:'11px'}}>{t("I18N_TIP_Add_user")}</Tooltip>}>
                <span onClick={handleAddUsers} style={{ marginLeft: '0px', marginRight: '0px', marginTop: '3px', cursor: 'pointer', color: 'rgb(100,100,100)' }}>
                  <BiPlus size={18} />
                </span>
              </OverlayTrigger>
            </span>
*/}
          </div>

          <hr className="solid" style={{ margin: '0 0 0 0' }}></hr>

          <div style={{overflow:'auto', maxHeight:'245px', fontSize:'11px', marginTop:'10px'}}>

            <Table hover responsive size="sm">
              <thead style={{color:'#686868', fontSize:'12px', borderBottom:"2px solid #D0D0D0"}}>
                <tr>
                  <th style={{fontWeight:'400'}}>{t("I18N_Username")}</th>
                  <th style={{fontWeight:'400'}}>{t("I18N_Status")}</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                {(userList && userList.length > 0) ? userList.map(renderUser) : null}
              </tbody>
            </Table>
          </div>
        </div>

        <hr className="solid" style={{ marginTop: '30px' }}></hr>

        <div className={classes.admin_pages__page_subtitle} >
          <Form.Group as={Row} className="mb-2 mt-3">
            <div style={{ display: "flex" }}>
              <Button size="sm" variant="outline-secondary" className="mb-3"
                style={{ fontSize: '12px', fontWeight: '300' }}
                onClick={handleClose}>
                {t("I18N_Close")}
              </Button>
              <span className={classes.admin_pages__field_label} style={{ marginLeft: '20px', color: 'rgba(200,0,0)' }}>
                {errMsg}
              </span>
            </div>
          </Form.Group>
        </div>

{/*
        <Modal show={showAddUserDialog} onHide={handleAddUsersClose} centered >
          <Modal.Body>

            <div className={classes.admin_pages__page_subtitle} style={{marginTop:'0px'}}>
              <div display='flex'>
                <span>
                  {t("I18N_Users")}
                </span>
              </div>

              <hr className="solid" style={{ margin: '0 0 10px 0' }}></hr>
            </div>

            <div style={{overflow:'auto', fontSize:'11px', marginTop:'10px'}}>
              <Table hover responsive size="sm">
                <thead style={{color:'#686868', fontSize:'12px', borderBottom:"2px solid #D0D0D0"}}>
                  <tr>
                    <th></th>
                    <th style={{fontWeight:'400'}}>{t("I18N_Username")}</th>
                  </tr>
                </thead>
                <tbody>
                  {unassignedUserList ? unassignedUserList.map(renderAddNotifs) : null}
                </tbody>
              </Table>
            </div>

            <div display='flex' style={{ marginTop: '15px' }}>
              <Button size="tiny" variant="outline-secondary" className="mb-3"
                style={{ float: 'left' }}
                onClick={handleAddUsersClose}>
                {t("I18N_Cancel")}
              </Button>
              <Button size="tiny" variant="outline-secondary" className="mb-3"
                style={{ marginLeft: '15px' }}
                onClick={handleAddUsersSubmit}>
                {t("I18N_Add_users")}
              </Button>
              <span className={classes.admin_pages__field_label} style={{ marginLeft: '30px', color: 'rgba(200,0,0)', verticalAlign: 'top' }}>
                {addUserErrMsg}
              </span>
            </div>
          </Modal.Body>
        </Modal>
*/}

        <Modal show={showDeleteConfirmDialog} onHide={handleDeleteConfirmCancel} centered >
          <Modal.Body>
            <div className={classes.admin_pages__page_subtitle} style={{marginTop:'10px'}}>
              <div>
                {t("I18N_Notif_delete_recipient")}
              </div>
              <div style={{marginTop:'5px', fontStyle:'italic'}}>
                {deleteTarget ? deleteTarget.username : ''}
              </div>

              <form>
                <Row>
                  <span className={classes.admin_pages__field_label} style={{marginTop:'5px', color:'rgba(200,0,0)', verticalAlign:'top'}}>
                    {errMsgDeleteConfirm}
                  </span>
                </Row>
                <Row>
                  <div display='flex' style={{marginTop:'15px'}}>
                    <Button size="tiny" variant="outline-secondary" className="mb-3" style={{ float: 'left' }}
                      onClick={handleDeleteConfirmCancel}>
                      {t("I18N_Cancel")}
                    </Button>
                    <Button size="tiny" variant="outline-secondary" className="mb-3" style={{ marginLeft: '15px' }}
                      onClick={handleDeleteConfirmSubmit}>
                      {t("I18N_Yes")}
                    </Button>
                  </div>
                </Row>
              </form>
            </div>
          </Modal.Body>
        </Modal>

      </Card>
    </>
  );
}
 
export default NotifAdminDetailsView;
